module.exports = __webpack_public_path__ + "static/img/image3.cb6fb15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/image3.jpg
// module id = 5mVt
// module chunks = 26